export const appEnv = process.env.REACT_APP_APP_ENV
export const envVersion = process.env.REACT_APP_VERSION
export const cszUrl = process.env.REACT_APP_CSZ_URL
export const apiUrl = process.env.REACT_APP_CSZ_API_URL

export function showVersion() {
  console.info(`Team Schedules widget v${envVersion} (${appEnv})`)
}

export const DEFAULT_SEASON = '2026-2027'
